import { html } from "lit-html"
import { virtual } from "haunted"

import { HeaderSection, LocationInfo, DateTimeInfo } from "./components"
import { ActionButtons } from "./components/header"

import { STATUSES } from "../constants"

const getDisplayStatus = (status) => {
  const statusLower = status.toLowerCase()
  return ["canceled", "deleted", "rescheduled"].includes(statusLower)
    ? status
    : ``
}

const MeetingRow = virtual(
  ({
    id,
    name,
    url,
    status,
    agency,
    start_date,
    start_time,
    end_time,
    shortened_timezone,
    tags,
    remote,
    link,
    location,
    gcal_link,
    can_edit,
    can_clone,
  }) => {
    const $filterMount = document.getElementById("filter-mount")
    const iconIcalSrc = $filterMount.dataset.iconIcal
    const iconGoogleCalendarSrc = $filterMount.dataset.iconGoogleCalendar

    const meetingStatus = getDisplayStatus(status)
    const canceled = status === STATUSES.CANCELED
    const primaryTags = tags
      .filter((tag) => !("primary" in tag) || tag.primary)
      .map((tag) => tag.name)

    return html`
      <div
        class="meeting group filter-result-card cursor-pointer ${canceled
          ? `inactive`
          : ``}"
        role="button"
        @click=${() => {
          window.location.href = url
        }}
      >
        ${meetingStatus || primaryTags.length
          ? html`${HeaderSection(
              {
                status: meetingStatus,
                tags: primaryTags,
                id,
                url,
                can_edit,
                can_clone,
                can_convert_to_assignment: can_edit,
                iconIcalSrc,
                iconGoogleCalendarSrc,
                gcal_link,
              },
              true
            )}`
          : ""}
        <div class="mb-5 flex flex-col-reverse md:flex-row justify-between">
          <p class="title text-lg text-blue group-hover:text-black font-bold">
            ${name}
          </p>
          ${meetingStatus || primaryTags.length
            ? ""
            : html`<div class="ml-auto mb-5 md:mb-0">
                ${ActionButtons({
                  id,
                  url,
                  can_edit,
                  can_clone,
                  can_convert_to_assignment: can_edit,
                  iconIcalSrc,
                  iconGoogleCalendarSrc,
                  gcal_link,
                  expanded: true,
                })}
              </div>`}
        </div>
        <div class="flex flex-wrap leading-loose">
          ${LocationInfo({ location, link, remote, canceled })}
          ${DateTimeInfo({
            date: start_date,
            start_time,
            end_time,
            shortened_timezone,
            canceled,
            agency,
          })}
        </div>
      </div>
    `
  }
)

export default MeetingRow
